import React from 'react';
import { motion } from 'framer-motion';
import { PhoneCall } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function FinalCTA() {
  const {
    t
  } = useLanguage();
  return <section id="agenda" className="py-12 md:py-24 bg-brand-gold relative overflow-hidden" data-id="element-116" data-mp="c70wp6v119mz">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-117" data-mp="87jsshv90kjx">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjIiIGZpbGw9IiNmZmYiLz48L3N2Zz4=')] bg-[length:20px_20px]" data-id="element-118" data-mp="m3wzqx25p3k5"></div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-119" data-mp="qvx6b8cqeupp">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-120" data-mp="14vg16zgj89k2">
          <h2 className="text-3xl md:text-5xl font-serif text-white mb-6 md:mb-8 leading-tight" data-id="element-121" data-mp="2h3hruxxwxeal">
            {t('cta.title')}
          </h2>

          <p className="text-xl text-brand-cream mb-10 max-w-2xl mx-auto" data-id="element-122" data-mp="2m19fvgvfsg9i">
            {t('cta.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-123" data-mp="2qzuhnkqc7802">
            <a href="https://wa.me/15513328938?text=Hola%2C%20me%20gustar%C3%ADa%20reservar%20una%20cita" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 bg-white text-brand-gold px-8 py-4 rounded-sm font-bold text-lg hover:bg-brand-cream transition-colors shadow-xl w-full sm:w-auto" data-id="element-124" data-mp="2v38ygdm3nsek">
              <PhoneCall className="w-5 h-5" data-id="element-125" data-mp="3etcmgx0gdawx" />
              {t('cta.btn')}
            </a>
            <p className="text-white/80 text-sm font-medium" data-id="element-126" data-mp="3itmv6hfmqffh">
              {t('cta.footer')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}